import React from "react";
import styled from "styled-components";
const imageScale = 0.5;

function makeNineSliceImageDiv(image, leftWidth, rightWidth, topHeight, bottomHeight, borderOffset) {
  return styled.div.withConfig({
    displayName: "NineSlices",
    componentId: "sc-lubqdh-0"
  })(["position:absolute;width:100%;height:100%;box-sizing:border-box;border:0px solid white;border-left-width:", "px;border-right-width:", "px;border-top-width:", "px;border-bottom-width:", "px;border-image-source:url(\"", "\");border-image-slice:", " ", " ", " ", " fill;"], leftWidth * imageScale + borderOffset, rightWidth * imageScale + borderOffset, topHeight * imageScale + borderOffset, bottomHeight * imageScale + borderOffset, image, topHeight, rightWidth, bottomHeight, leftWidth);
}

const NiceSliceContainer = styled.div.withConfig({
  displayName: "NineSlices__NiceSliceContainer",
  componentId: "sc-lubqdh-1"
})(["position:relative;overflow:hidden;margin:", ";"], ({
  marginLeft,
  marginRight,
  marginTop,
  marginBottom
}) => `${marginTop}px ${marginRight}px ${marginBottom}px ${marginLeft}px`);
const NineSliceContent = styled.div.withConfig({
  displayName: "NineSlices__NineSliceContent",
  componentId: "sc-lubqdh-2"
})(["position:relative;margin:", ";min-width:", ";"], ({
  marginLeft,
  marginRight,
  marginTop,
  marginBottom
}) => `${marginTop}px ${marginRight}px ${marginBottom}px ${marginLeft}px`, props => props.minWidth ? props.minWidth + "px" : undefined);

function makeNineSlice(imageNumber, leftWidth, rightWidth, topHeight, bottomHeight, marginOffsetLeft, marginOffsetRight, marginOffsetTop, marginOffsetBottom, outerMarginOffsetLeft, outerMarginOffsetRight, outerMarginOffsetTop, outerMarginOffsetBottom, minWidth) {
  const image = `assets/game/images/9slices/${imageNumber}_9Slice.png`;
  const BackgroundLayer = makeNineSliceImageDiv(image, leftWidth, rightWidth, topHeight, bottomHeight, 1);
  const ForegroundLayer = makeNineSliceImageDiv(image, leftWidth, rightWidth, topHeight, bottomHeight, 0);

  const component = ({
    children,
    className
  }) => {
    return /*#__PURE__*/React.createElement(NiceSliceContainer, {
      className: className,
      marginLeft: outerMarginOffsetLeft,
      marginRight: outerMarginOffsetRight,
      marginTop: outerMarginOffsetTop,
      marginBottom: outerMarginOffsetBottom
    }, /*#__PURE__*/React.createElement(BackgroundLayer, null), /*#__PURE__*/React.createElement(ForegroundLayer, null), /*#__PURE__*/React.createElement(NineSliceContent, {
      marginLeft: leftWidth * imageScale + marginOffsetLeft,
      marginRight: rightWidth * imageScale + marginOffsetRight,
      marginTop: topHeight * imageScale + marginOffsetTop,
      marginBottom: bottomHeight * imageScale + marginOffsetBottom,
      minWidth: minWidth
    }, children));
  };

  return component;
}

const NineSlice0 = makeNineSlice("00", 133, 133, 112, 44, -30, -30, -10, 5, 0, 0, 0, 0, 61); //const NineSlice1 = makeNineSlice("01", 125, 125, 125, 125, 0, 0, 0, 0, 0, 0, 0, 0);

const NineSlice2 = makeNineSlice("02", 75, 75, 75, 75, -10, -10, -8, -8, 0, 0, 0, 0);
const NineSlice3 = makeNineSlice("03", 55, 55, 55, 55, 0, 0, 0, 0, 0, 0, 0, 0);
const NineSlice4 = makeNineSlice("04", 55, 55, 55, 55, 0, 0, 0, 0, 0, 0, 0, 0);
const NineSlice5 = makeNineSlice("05", 125, 125, 125, 125, -22, -22, -12, -12, 0, 0, 0, 0); //const NineSlice6 = makeNineSlice("06", 125, 125, 125, 125, 0, 0, 0, 0, 0, 0, 0, 0);

const NineSlice7 = makeNineSlice("07", 125, 125, 125, 125, -28, -28, -15, -15, -8, -8, -8, -8);
const NineSlice8 = makeNineSlice("08", 125, 125, 125, 125, -22, -22, -12, -12, 0, 0, 0, 0); //const NineSlice9 = makeNineSlice("09", 125, 125, 125, 125, -22, -22, -12, -12, 0, 0, 0, 0);

const NineSlice10 = makeNineSlice("10", 50, 50, 60, 60, 0, 0, -7, 0, 0, 0, 0, 0);
const NineSlice11 = makeNineSlice("11", 88, 88, 128, 54, -15, -15, 0, 0, 0, 0, 0, 0); //const NineSlice12 = makeNineSlice("12", 90, 90, 130, 50, 0, 0, 0, 0, 0, 0, 0, 0);

export const TimerWindow = NineSlice0;
export const InventoryWindow = NineSlice7;
export const QuestWindow = NineSlice7;
export const NotificationWindow = NineSlice7;
export const DialogueSpeakerWindow = NineSlice4;
export const DialogueTextWindow = NineSlice5;
export const DialogueTextWindowWithoutSpeaker = NineSlice8;
export const DialogueAnswerWindow = NineSlice2;
export const TextActionWindow = NineSlice3;
export const Button = NineSlice10; //const ButtonPressed = NineSlice12;

export const NotificationNineSlice = NineSlice11;